<template>
  <BaseCardV2
    :has-btn-action="false"
    :loading="loading"
    has-help
    titre="évolution des rendements"
    @on-help="isOpenModalHelp = true"
  >
    <BaseComparaisonLegende
      v-if="!loading && !isRendementIncoherent"
      :donnee-groupe="hasDonneesGroupe && hasRegionSelected ? {libelle:'Mon groupe'} : null"
      :donnee-perso="{libelle:'Mon rendement'}"
      :couleur-primaire="datasetRendementNumtiers.borderColor"
      :couleur-secondaire="datasetRendementGroupe.borderColor"
      class="ml-3 my-5"
    />
    <BaseComparaisonLineChart
      v-if="!loading && !isRendementIncoherent"
      :id="chartData.id"
      :chart-data="chartData"
      :ordonnee="uniteRendement"
      :precision="precisionRendement"
      :unite="uniteRendement"
      class="mt-5 px-5"
      tooltip-label-groupe="Mon groupe "
      tooltip-label-perso="Mon rendement : "
    />
    <div v-if="!loading && isRendementIncoherent">
      <BaseMessage
        class="mx-5 mt-3"
        color="secondary"
        text
        type="info"
      >
        Rendement incohérent : nous ne pouvons pas afficher votre analyse.
      </BaseMessage>
    </div>
    <HelpModal
      v-if="isOpenModalHelp"
      titre="évolution des rendements"
      :is-open-modal-help="isOpenModalHelp"
      @close="isOpenModalHelp = false"
    >
      <div slot="baseCardHelpContent">
        <div class="texte text-justify texte-gris-fonce pa-8">
          <p>
            Vos rendements sont ceux indiqués ou calculés sur la page Mes cultures.
          </p>
          <p>Les rendements du groupe correspondent à la moyenne des rendements renseignés sur la page Mes cultures par les adhérents de votre groupe de comparaison (par défaut votre région). </p>
        </div>
      </div>
    </HelpModal>
  </BaseCardV2>
</template>

<script>
import BaseCardV2 from '@/components/card/base-card-v2.vue'
import BaseComparaisonLineChart from '@/components/chart/base-comparaison-line-chart.vue'
import BaseComparaisonLegende from '@/components/chart/base-comparaison-legende.vue'
import HelpModal from '@/components/modal/help-modal.vue'
import {mapGetters} from 'vuex'
import colorsService from '@/service/colors.service'
import BaseMessage from '@/components/common/base-message.vue'
import { convertirRendement, isLinFibre, precisionRendement, uniteRendement } from '@/utils/rendement'

export default {
  name: 'EvolutionRendements',
  components: { HelpModal, BaseCardV2, BaseMessage, BaseComparaisonLineChart, BaseComparaisonLegende },
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    typeCulture: {
      type: Object,
      required: true
    },
    isRendementIncoherent: {
      type: Boolean,
      default: false
    },
    hasRegionSelected: {
      type: Boolean,
      default: null
    }
  },
  data () {
    return {
      opacity: 0.75,
      isOpenModalHelp: false,
      erreur: false
    }
  },
  computed: {
    ...mapGetters({
      rendementNumtiers: 'rendement/rendementNumtiers',
      rendementGroupe: 'rendement/rendementGroupe',
      filtresAdherent: 'filtresComparaison/filtresAdherent'
    }),
    isLinFibre () {
      return isLinFibre(this.typeCulture)
    },
    chartData () {
      let datasets = [this.datasetRendementNumtiers]
      if (this.hasRegionSelected) { 
        datasets.push(this.datasetRendementGroupe)
      }
      
      return {
        title: '',
        labels: this.rendementNumtiers.map(r => r.annee),
        datasets: datasets,
        unite: this.uniteRendement,
        hasDonneesNumtiers: this.hasDonneesEvolutionNumtiers,
        id: 'chartEvolutionRendement' + Math.random()
      }
    },
    datasetRendementNumtiers () {
      return {
        type: 'line',
        label: 'Mon exploitation',
        fill: false,
        tension: 0.3,
        borderColor: colorsService.barChart.grapheCompositionQualite.perso,
        backgroundColor: colorsService.barChart.grapheCompositionQualite.perso,
        data: this.rendementNumtiers.map(r => convertirRendement(r.rendement, this.typeCulture))
      }
    },
    datasetRendementGroupe () {
      const serie = this.rendementGroupe.rendementsAnnuelsGroupe
      return {
        type: 'line',
        label: 'Mon groupe',
        fill: false,
        tension: 0.3,
        pointRadius: this.hasDonneesEvolutionNumtiers ? 3 : 0,
        showLine: this.hasDonneesEvolutionNumtiers,
        borderColor: colorsService.barChart.grapheCompositionQualite.groupe,
        backgroundColor: colorsService.barChart.grapheCompositionQualite.groupe,
        data: this.hasDonneesEvolutionNumtiers && serie != null
          ? serie.map(r => convertirRendement(r.rendementAnnuel.rendement, this.typeCulture))
          : [10, 20, 30, 40],
        nbGroupe: serie != null ? serie.map(r => r.nbAdherentCompares) : []
      }
    },
    uniteRendement () {
      return uniteRendement(this.typeCulture)
    },
    precisionRendement () {
      return precisionRendement(this.typeCulture)
    },
    hasDonneesEvolutionNumtiers () {
      return this.rendementNumtiers.map(r => r.rendement).filter(f => f != null).length > 0
    },
    hasDonneesGroupe () {
      return this.rendementGroupe.rendementsAnnuelsGroupe.map(r => r.nbAdherentCompares).filter(f => f > 0).length > 0
    },
  }

}
</script>
